<div *ngIf="title" class="title-container">
  <h1>{{ title }}</h1>
</div>
<object *ngIf="link" type="text/html" [data]="link | safe : 'resourceUrl'"></object>
